import PropTypes from "prop-types";

export default PropTypes.shape({
  performance: PropTypes.shape({
    memberSince: PropTypes.string.isRequired,
    interviewRate: PropTypes.number.isRequired,
    placementRate: PropTypes.number.isRequired,
    engagements: PropTypes.number.isRequired,
    submissions: PropTypes.number.isRequired,
    interviews: PropTypes.number.isRequired,
    placements: PropTypes.number.isRequired,
    averageCVs: PropTypes.number.isRequired,
  }),
  pipeline: PropTypes.shape({
    interviews: PropTypes.number.isRequired,
    interviewsCount: PropTypes.number.isRequired,
    engagements: PropTypes.number.isRequired,
    engagementsCount: PropTypes.number.isRequired,
  }),
});
